import React from 'react';

export const widgetTypes = {
  DEFAULT: 'widget-default',
  CUSTOM_A: 'widget-custom-type-a',
  INTRO: 'widget-intro',
  TREND_TYPE: 'trend-type',
  NO_MIN_WIDTH: 'no-min-width',
};

export const addedHeaderTypes = {
  BUTTON: 'BUTTON',
  TABS: 'TABS',
  SELECT: 'SELECT',
};

export const tabs = {
  riskOverview: {
    icon: (
      <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_4795_91)">
          <path d="M16.4868 13.0312L9.82118 1.65625C9.31087 0.78125 8.02306 0.78125 7.50931 1.65625L0.846808 13.0312C0.333995 13.9031 0.972714 15 2.00056 15H15.3318C16.3556 15 16.9962 13.9062 16.4868 13.0312ZM7.91493 5.25C7.91493 4.83594 8.25087 4.5 8.66493 4.5C9.07899 4.5 9.41493 4.8375 9.41493 5.25V9.25C9.41493 9.66406 9.079 10 8.69306 10C8.30712 10 7.91493 9.66562 7.91493 9.25V5.25ZM8.66493 13C8.12243 13 7.68243 12.56 7.68243 12.0175C7.68243 11.475 8.12212 11.035 8.66493 11.035C9.20775 11.035 9.64743 11.475 9.64743 12.0175C9.64618 12.5594 9.20868 13 8.66493 13Z"  />
        </g>
        <defs>
          <clipPath id="clip0_4795_91">
            <rect width="16" height="16" fill="white" transform="translate(0.665039)" />
          </clipPath>
        </defs>
      </svg>
    ),
    label: 'Risk Overview',
    widget: 'riskOverview',
    check: (data) => true, //data.provenanceRisk && data.supplyChainRisk,
  },
  subjectAnalysis: {
    icon: (
      <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.1006 6.5C13.1006 7.93437 12.635 9.25938 11.8225 10.3344L15.8068 14.2937C16.1975 14.6844 16.1975 15.3156 15.8068 15.7063C15.4162 16.0969 14.785 16.0969 14.3943 15.7063L10.435 11.7219C9.35996 12.5344 8.03496 13 6.60059 13C3.01059 13 0.100586 10.0906 0.100586 6.5C0.100586 2.91 3.01059 0 6.60059 0C10.1912 0 13.1006 2.91 13.1006 6.5ZM3.35059 8.75C3.35059 9.16562 3.68496 9.5 4.10059 9.5C4.51621 9.5 4.85059 9.16562 4.85059 8.75V6.75C4.85059 6.33437 4.51621 6 4.10059 6C3.68496 6 3.35059 6.33437 3.35059 6.75V8.75ZM5.85059 8.75C5.85059 9.16562 6.18496 9.5 6.60059 9.5C7.01621 9.5 7.35059 9.16562 7.35059 8.75V3.75C7.35059 3.33437 7.01621 3 6.60059 3C6.18496 3 5.85059 3.33437 5.85059 3.75V8.75ZM8.35059 8.75C8.35059 9.16562 8.68496 9.5 9.10059 9.5C9.51621 9.5 9.85059 9.16562 9.85059 8.75V5.75C9.85059 5.33437 9.51621 5 9.10059 5C8.68496 5 8.35059 5.33437 8.35059 5.75V8.75Z"  />
      </svg>
    ),
    label: 'Subject Analysis',
    widget: 'subjectAnalysis',
    check: (data) => true,//data.locationAnalysis && data.paritcipantAnalysis,
  },
  associatedEvents: {
    icon: (
      <svg width="17" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.03613 1V2H9.03613V1C9.03613 0.447812 9.48301 0 10.0361 0C10.5893 0 11.0361 0.447812 11.0361 1V2H12.5361C13.3643 2 14.0361 2.67156 14.0361 3.5V5H0.0361328V3.5C0.0361328 2.67156 0.707695 2 1.53613 2H3.03613V1C3.03613 0.447812 3.48301 0 4.03613 0C4.58926 0 5.03613 0.447812 5.03613 1ZM0.0361328 6H14.0361V14.5C14.0361 15.3281 13.3643 16 12.5361 16H1.53613C0.707695 16 0.0361328 15.3281 0.0361328 14.5V6ZM2.53613 8C2.25988 8 2.03613 8.225 2.03613 8.5V11.5C2.03613 11.775 2.25988 12 2.53613 12H5.53613C5.81113 12 6.03613 11.775 6.03613 11.5V8.5C6.03613 8.225 5.81113 8 5.53613 8H2.53613Z" />
      </svg>
    ),
    label: 'Associated Events',
    widget: 'associatedEvents',
    check: (data) => data.subjectDataConsolidation && data.informationContributions && data.sourcesOfInformation && data.informationClients,
  },
}
